module.exports = __webpack_public_path__ + "static/img/bg_title@2x.186cc6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK_pc/bg_title@2x.png
// module id = FBAJ
// module chunks = 69